export const defaultColors = [
  "#D35934", // Orange-red
  "#6934D3", // Purple
  "#D334C8", // Pink/Magenta
  "#D3A934", // Yellow/Gold
  "#34D36C", // Bright green
  "#34B3D3", // Aqua blue
  "#D38434", // Amber/Orange
  "#34D3B0", // Mint green
  "#D33463", // Deep pink
  "#A934D3", // Violet
  "#D3C634", // Bright yellow
  "#34D3E9", // Cyan
  "#D34734", // Red-orange
  "#34D3D0", // Turquoise
  "#D3349E", // Hot magenta
  "#7B34D3", // Deep purple
  "#D36B34", // Warm orange
  "#34D359", // Lime green
  "#34A3D3", // Sky blue
  "#D38434", // Burnt orange
];
